import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Stack,
} from "@mui/material";
import PlayingCard from "../../cmp/PlayingCard";
import { useRecoilState, useRecoilValue } from "recoil";
import { Hand, Deck, Stuck, nertzPlayerMessage } from "../../api/NertzApi";
import {
  PauseTwoTone,
  SentimentDissatisfiedTwoTone,
} from "@mui/icons-material";
import CardSlot from "../../cmp/CardSlot";
import { DragCard } from "../../api/CardApi";
import { useParams } from "react-router-dom";

function NertzHand() {
  const params = useParams(),
    [deck, setDeck] = useRecoilState(Deck),
    [hand, setHand] = useRecoilState(Hand),
    dragCard = useRecoilValue(DragCard),
    [stuck, setStuck] = useRecoilState(Stuck),
    handleDeckOver = (e) => {
      if (dragCard && dragCard.cardType === "hand" && !deck.length) {
        e.preventDefault();
      }
    },
    handleDeckDrop = (e) => {
      e.preventDefault();

      setDeck([...hand]);
      setHand([]);
    },
    handleHandOver = (e) => {
      if (dragCard && dragCard.cardType === "deck") {
        e.preventDefault();
      }
    },
    handleHandDrop = (e) => {
      e.preventDefault();

      if (!hand.length) {
        setStuck(true);
      }

      setHand([...hand, ...deck.slice(0, 3)]);
      setDeck(deck.slice(3));
    };

  return (
    <Card id="nertz-hand" raised>
      <CardHeader
        action={
          <IconButton
            onClick={() => {
              nertzPlayerMessage(params.id, {
                player: {
                  isPaused: true,
                },
              });
            }}
            title="Pause Game"
          >
            <PauseTwoTone />
          </IconButton>
        }
        title="My Hand"
      />
      <CardContent>
        <Stack direction="row" spacing={1}>
          {deck.length ? (
            <PlayingCard cardType="deck" rank={0} suit={0} />
          ) : (
            <CardSlot onDragOver={handleDeckOver} onDrop={handleDeckDrop} />
          )}
          {hand.length ? (
            <PlayingCard
              cardType="hand"
              {...hand[hand.length - 1]}
              onDragOver={handleHandOver}
              onDrop={handleHandDrop}
            />
          ) : (
            <CardSlot onDragOver={handleHandOver} onDrop={handleHandDrop}>
              {stuck ? (
                <Stack sx={{ height: 1 }}>
                  <Box sx={{ flexGrow: 1 }} />
                  <Button
                    startIcon={<SentimentDissatisfiedTwoTone />}
                    sx={{ margin: "0 auto" }}
                    variant="contained"
                    onClick={() => {
                      nertzPlayerMessage(params.id, {
                        player: { isStuck: true },
                      });
                    }}
                  >
                    Stuck
                  </Button>
                  <Box sx={{ flexGrow: 1 }} />
                </Stack>
              ) : null}
            </CardSlot>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}

export default NertzHand;
